import React, { useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap"
import { Controller, useForm } from "react-hook-form"
import { NumericFormat } from "react-number-format";
import FileUpload from "../../../../components/fileupload";
import BidPanel from "./bids/bidpanel";
import InspectionsPanel from "./inspections/inspectionspanel";
import { ReplaceNullsWithEmptyStrings } from "../../../../utilities/rhfdatanormalizationfunctions";
import useApi from "../../../../hooks/use-api";
import { appendFormData } from "../../../../utilities/formdata";
import useMessageStore from "../../../../stores/message-store";

const PropertyEdit = ({ApplicationID,PropertyID,ReturnFunction,RefreshFunction,States = [],Actions = [],InspectionStatuses = [],InspectionTypes = []}) => {
    const [isLoading,setIsLoading] = useState(true); //Default to true

    const [bids,SetBids] =  useState([]);
    const [inspections,SetInspections] = useState([]);
    const [existingPrimaryFiles,setExistingPrimaryFiles] = useState([]);
    const [initialExistingPrimaryFiles,setInitialExistingPrimaryFiles] = useState([]);
    const [newPrimaryFiles,setNewPrimaryFiles] = useState([]);

    const [initialBids,setInitialBids] = useState([]);
    const [initialInspections,setInitialInspections] = useState([]);

    const initialValues = {
        address: '',
        city: '',
        state: '',
        zip: '',
        name: '',
        phone: '',
        email: '',
        notes: '',
        pvavalue: null
    }

    const addToast = useMessageStore(state => state.addToast);

    const {handleSubmit,register,control,watch,resetField,reset,formState: {isDirty,isSubmitting}} = useForm({defaultValues: initialValues});

    const {getRequest,putFileRequest} = useApi();

    const GetProperty = async() => {
        setIsLoading(true);

        const [data,status] = await getRequest('Property',{ApplicationID: ApplicationID,PropertyID: PropertyID,imestamp: Date.now()});

        setIsLoading(false);

        if(status === 200){
            const {id,bids,inspections,existingfiles,...Rest} = data;

            SetBids(bids);
            setInitialBids(bids);
            SetInspections(inspections);
            setInitialInspections(inspections);
            setExistingPrimaryFiles(existingfiles);
            setInitialExistingPrimaryFiles(existingfiles);

            const values = {
                ...Rest,
                state: `${Rest.state}`
            }

            reset(ReplaceNullsWithEmptyStrings(values));
        }
    }

    useEffect(() => {
        GetProperty();
    },[])

    const appendFormDataArray = (formData, array, keyPrefix) => {
    const buildFormData = (formData, data, parentKey) => {
        if (data && typeof data === 'object' && !(data instanceof File)) {
            Object.keys(data).forEach(key => {
                const value = data[key];
                const newKey = `${parentKey}.${key}`;
                buildFormData(formData, value, newKey);
            });
        } else {
            formData.append(parentKey, data == null ? '' : data);
        }
    };

    array.forEach((item, index) => {
        const itemKeyPrefix = `${keyPrefix}[${index}]`;
        buildFormData(formData, item, itemKeyPrefix);
    });
};


    const _handleSubmit = async(values) => {
        const sendObject = {
            ...values,
            ApplicationID: ApplicationID,
            PropertyID: PropertyID,
            existingfiles: existingPrimaryFiles,
            newfiles: newPrimaryFiles
        }

        const formData = new FormData();
                
        appendFormData(formData,sendObject);
        
        for (let index = 0; index < newPrimaryFiles.length; index++) {
            const element = newPrimaryFiles[index].file;
          
            formData.append(`newfiles`, element);
        }

        const modifiedBids = bids.map((item) => {
            let {bidupload,checkupload,...rest} = item;
            
            const rVal = {
                ...rest,
                newbidupload: bidupload instanceof File ? bidupload : null,
                existingbidupload: bidupload instanceof File ? null : bidupload,
                newcheckupload: checkupload instanceof File ? checkupload : null,
                existingcheckupload: checkupload instanceof File ? null : checkupload
            }

            return rVal;
        })

        const modifiedInspections = inspections.map((item) => {
            let {inspectionreport, clientsignedwaiver, ...rest} = item;

            const rVal = {
                ...rest,
                inspectionreportnew: inspectionreport instanceof File ? inspectionreport : null,
                inspectionreportexisting: inspectionreport instanceof File ? null : inspectionreport,
                clientsignedwaivernew: clientsignedwaiver instanceof File ? clientsignedwaiver : null,
                clientsignedwaiverexisting: clientsignedwaiver instanceof File ? null : clientsignedwaiver
            }

            return rVal;
        })

        appendFormDataArray(formData,modifiedBids,'bids');
        appendFormDataArray(formData,modifiedInspections,'inspections');
                
        const [data,status] = await putFileRequest('UpdateProperty',formData)

        if(status === 200){

            const {id,bids,inspections,existingfiles,...Rest} = data;

            SetBids(bids);
            setInitialBids(bids);
            SetInspections(inspections);
            setInitialInspections(inspections);
            setNewPrimaryFiles([]);
            setExistingPrimaryFiles(existingfiles);
            setInitialExistingPrimaryFiles(existingfiles);

            const values = {
                ...Rest,
                state: `${Rest.state}`
            }

            reset(ReplaceNullsWithEmptyStrings(values));

            addToast({
                    id: Math.random(),
                    body: 'Property Updated successfully!',
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
            })

            RefreshFunction();
            
        }
        else{
            addToast({
                    id: Math.random(),
                    body: 'An error occured when updating the property.',
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
            })
        }
    }
     
    const bidsChanged = JSON.stringify(bids) !== JSON.stringify(initialBids);
    const inspectionsChanged = JSON.stringify(inspections) !== JSON.stringify(initialInspections);
    const filesChanged = existingPrimaryFiles.length !== initialExistingPrimaryFiles.length;

    if(isLoading){
        return(
            <div>loading...</div>
        )
    }

    return(
        <form onSubmit={handleSubmit(_handleSubmit)}>
            <div className="clientCard">
                <div className="clientCardInner">
                    <h4 className="mb-0 text-center">Edit Property Information</h4>
                    <div className="mt-2" style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black',padding: '4px'}}>
                        <Row>
                            <Col xs={12}>
                                <h5>Property Information</h5>
                            </Col>
                            <Col xs={12} md={9}>
                                <label htmlFor="address">Address</label>
                                <input type="text" id="address" {...register('address')} style={{width: '100%',height: '32px'}}/>
                            </Col>
                            <Col xs={12} md={3}>
                                <label htmlFor="pvavalue">PVA Value ($)</label>
                                <Controller
                                    name="pvavalue"
                                    control={control}
                                    render={({ field }) => (
                                        <NumericFormat 
                                            value={field.value} 
                                            id="pvavalue" 
                                            placeholder="PVA Value" 
                                            style={{ width: '100%', height: '32px' }} 
                                            prefix={'$'} 
                                            decimalScale={2} 
                                            fixedDecimalScale={true} 
                                            allowNegative={false}
                                            onValueChange={(values) => {
                                                if(values.floatValue === undefined || values.floatValue === null){
                                                    field.onChange(initialValues.pvavalue); //Reset to default
                                                }
                                                else{
                                                    field.onChange(values.floatValue);
                                                }
                                            }} 
                                        />
                                    )}
                                />
                            </Col>
                            <Col xs={12} md={5}>
                                <label htmlFor="city">City</label>
                                <input type="text" id="city" {...register('city')} style={{width:'100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="state">State</label>
                                <select id="state" {...register('state')} style={{width: '100%',height: '30px'}}>
                                    <option value=''>--Select a state--</option>
                                    {
                                        States.map((state) => (
                                            <option key={state.id} value={state.id}>{state.name}</option>
                                        ))
                                    }
                                </select>
                            </Col>
                            <Col xs={12} md={3}>
                                <label htmlFor="zip">Zip</label>
                                <input type="text" id="zip" {...register('zip')} style={{width:'100%'}} />
                            </Col>
                            <Col xs={12} md={5}>
                                <label htmlFor="name">Name</label>
                                <input type="text" id="name" {...register('name')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={4}>
                                <label htmlFor="email">Email</label>
                                <input type="text" id="email" {...register('email')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12} md={3}>
                                <label htmlFor="phone">Phone</label>
                                <input type="text" id="phone" {...register('phone')} style={{width: '100%'}} />
                            </Col>
                            <Col xs={12}>
                                <label htmlFor="notes">Notes</label>
                                <textarea id="notes" {...register('notes')} rows={4} style={{width: '100%'}} />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <BidPanel fields={bids} actionTypes={Actions} setFields={SetBids}/>
                        </Row>
                        <Row className="mt-4">
                            <InspectionsPanel fields={inspections} setFields={SetInspections} ActionTypes={Actions} InspectionStatuses={InspectionStatuses} InspectionTypes={InspectionTypes}/>
                        </Row>
                        <Row className="mt-4 mb-4">
                            <Col xs={12}>
                                <FileUpload
                                    title="Supporting Documents"
                                    previousFiles={existingPrimaryFiles} 
                                    newFiles={newPrimaryFiles} 
                                    setNewFiles={setNewPrimaryFiles} 
                                    setPrevFiles={setExistingPrimaryFiles}
                                    FileDownloadData={{ApplicationID: ApplicationID, HousingID: PropertyID}}
                                    prevFileDownloadEndpointKey='DownloadPropertyFiles'
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                        <Button type="button" variant="danger" onClick={ReturnFunction}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting || (!isDirty && !bidsChanged && !inspectionsChanged && !filesChanged && !newPrimaryFiles.length > 0)}>
                            {
                                isSubmitting
                                ?
                                    <Spinner animation='border' size='sm' />
                                :
                                    <>Save Changes</>
                            }
                        </Button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default PropertyEdit